import React, { CSSProperties } from 'react';
import { Alert } from 'react-bootstrap';

const YellowWarningBar = (props: { text: any }) => {
  const letOnlyAlertStyle: CSSProperties = {
    color: '#8a6d3b',
    backgroundColor: '#fcf8e3',
    borderBottom: '1px solid #ab8507',
    borderTop: '1px solid #ab8507',
    marginBottom: '5px',
    position: 'relative',
    bottom: '15px',
  };

  return (
    <Alert style={letOnlyAlertStyle} variant="warning" className="text-center">
      {props.text}
    </Alert>
  );
};

export default YellowWarningBar;
